/**
 * backendMode.js — a duhet përdorur backend-i real apo modaliteti demo?
 *
 * KUJDES: në production REACT_APP_API_URL është BOSH me qëllim, sepse nginx
 * proxyon URL-të relative (/api/... → backend). Prandaj `if (!API_URL)` NUK do
 * të thotë "s'ka backend" — në production është gjithmonë e vërtetë, dhe kthimi
 * në modalitetin demo i shfaqte përdoruesit të dhëna FIKTIVE nga localStorage
 * në vend të prezencës reale.
 *
 * REACT_APP_USE_BACKEND=true (i vendosur në .env.production) e detyron
 * backend-in real edhe kur baza është relative. Shih apiServices.js, që e
 * përdor të njëjtin flamur.
 */

/** Baza e API-t. Bosh në production = URL relative (nginx proxy). */
export const API_URL = process.env.REACT_APP_API_URL || '';

/** true kur .env e detyron backend-in real pavarësisht bazës relative. */
export const FORCE_BACKEND =
  String(process.env.REACT_APP_USE_BACKEND || '').toLowerCase() === 'true';

/**
 * Demo mode vetëm kur s'ka bazë API DHE s'është detyruar backend-i real.
 * Përdore këtë në vend të `if (!API_URL)`.
 */
export function isDemoMode() {
  return !API_URL && !FORCE_BACKEND;
}

export default { API_URL, FORCE_BACKEND, isDemoMode };
